import { Avatar, Tooltip } from "@mui/material";
import { getPermissionReadableName, PermissionType } from "../../../Core/Api/Types/permission-type";
import PermissionIcon from "./permission-icon";

interface PermissionAvatarProps {
  permission: PermissionType;
  variant: "primary" | "success" | "warning" | "error" | "info" | "accent";
  disabled?: boolean;
  showTooltip?: boolean;
}

const PermissionAvatar = (props: PermissionAvatarProps) => {
  const { permission, variant, disabled, showTooltip = false } = props;

  const avatar = (
    <Avatar
      sx={{
        bgcolor: disabled ? "backgroundAlpha.main" : `${[variant]}.alpha`,
        width: 24,
        height: 24,
      }}
    >
      <PermissionIcon permission={permission} color={disabled ? "disabled" : variant} fontSize="small" />
    </Avatar>
  );

  return (
    <>
      {showTooltip ? (
        <Tooltip title={getPermissionReadableName(permission)} arrow placement="bottom">
          {avatar}
        </Tooltip>
      ) : (
        avatar
      )}
    </>
  );
};

export default PermissionAvatar;
